import { useContext } from 'react'
import { useRouterStore } from './store'
import { PanelContext } from './components'
import { PanelHistoryItem } from './types'

export function usePanelHistoryTop(panel?: string) {
  const { name: containerPanelName } = useContext(PanelContext)

  return useRouterStore(state => {
    const history = state.panelsHistory[panel || containerPanelName]
    const panelTop = history?.peek()

    if (panelTop === 'INIT') {
      const [item] = history.toArray().slice(-2, -1)
      return (
        (item as PanelHistoryItem | undefined) || {
          location: '',
          state: undefined,
        }
      )
    }

    return panelTop || { location: '', state: undefined }
  })
}

export function useSectionHistory(section: string) {
  return useRouterStore(state => state.sectionsHistory[section]?.toArray())
}

export function useSectionHistoryTop(section: string) {
  return useRouterStore(state => {
    const history = state.sectionsHistory[section]
    const sectionTop = history?.peek()

    if (sectionTop === 'INIT') {
      const [panel] = history.toArray().slice(-2, -1)
      return panel
    }

    return sectionTop
  })
}

export function useActiveSectionsHistory() {
  return useRouterStore(state => state.activeSectionsHistory.toArray())
}

export function useActiveSectionsTop() {
  return useRouterStore(state => state.activeSectionsHistory.peek())
}
